import { getToolIds } from '../../../util/tool';
import {
  INSIGHTS_MENU,
  WIDGET_TYPE_ASSIGNMENT_SCORE_HISTOGRAM_CHART,
  WIDGET_TYPE_COMPLETED_ASSIGNMENT,
  WIDGET_TYPE_TIME_ATTEMPTS_CHART,
  WIDGET_TYPE_TIME_SCORE_CHART,
} from '../../constants';

export const getInsightsTag = (menu) => {
  switch (menu) {
    case INSIGHTS_MENU.ASSIGNMENT_PERFORMANCE:
      return 'Insights-assignment-performance';
    case INSIGHTS_MENU.COURSE_PERFORMANCE:
      return 'Insights-course-performance';
    case INSIGHTS_MENU.GRS:
      return 'Insights-grs-responses';
    default:
      return '';
  }
};

export const getAssignmentPerformanceWidgets = (assignmentId) => [
  {
    dashboardWidgetId: 13,
    widgetType: WIDGET_TYPE_ASSIGNMENT_SCORE_HISTOGRAM_CHART,
    title: 'What is the distribution of scores on this activity?',
    coordinates: {
      x: 0,
      y: 0,
      w: 1,
      h: 1,
    },
    assignmentIds: [assignmentId],
    isLoading: true,
  },
  {
    dashboardWidgetId: 11,
    widgetType: WIDGET_TYPE_TIME_ATTEMPTS_CHART,
    title:
      'How do student attempts on this activity compare to the total time taken?',
    coordinates: {
      x: 1,
      y: 0,
      w: 1,
      h: 1,
    },
    assignmentIds: [assignmentId],
    isLoading: true,
  },
  {
    dashboardWidgetId: 12,
    widgetType: WIDGET_TYPE_TIME_SCORE_CHART,
    title:
      'How do student scores on this activity compare to the total time taken?',
    coordinates: {
      x: 0,
      y: 1,
      w: 1,
      h: 1,
    },
    assignmentIds: [assignmentId],
    isLoading: true,
  },
  {
    dashboardWidgetId: 14,
    widgetType: WIDGET_TYPE_COMPLETED_ASSIGNMENT,
    title: 'How many students completed this assignment?',
    coordinates: {
      x: 1,
      y: 1,
      w: 1,
      h: 1,
    },
    assignmentIds: [assignmentId],
    isLoading: true,
  },
];

export const getCoursePerformanceWidgets = ({
  minRangeDays,
  maxRangeDays,
  hasExternalFramework,
}) => [
  {
    dashboardWidgetId: 23,
    widgetType: 'TOP_LO_BAR_CHART',
    title: 'What are the top learning objectives to review?',
    coordinates: {
      x: 0,
      y: 0,
      w: 1,
      h: 1,
    },
    rangeType: 'DAYS',
    minRangeDays,
    maxRangeDays,
    assignmentIds: [],
    isLoading: true,
  },
  {
    dashboardWidgetId: 24,
    widgetType: 'TOP_ASSIGNMENTS_BAR_CHART',
    title: 'What are the top assignments to review?',
    coordinates: {
      x: 1,
      y: 0,
      w: 1,
      h: 1,
    },
    rangeType: 'DAYS',
    minRangeDays,
    maxRangeDays,
    assignmentIds: [],
    isLoading: true,
  },
  {
    dashboardWidgetId: 25,
    widgetType: 'LOGIN_PIE_CHART',
    title: 'How often are students logging in?',
    coordinates: {
      x: 0,
      y: 1,
      w: 1,
      h: 1,
    },
    rangeType: 'DAYS',
    minRangeDays,
    maxRangeDays,
    assignmentIds: [],
    isLoading: true,
  },
  ...(hasExternalFramework
    ? [
        {
          dashboardWidgetId: 26,
          widgetType: 'TOP_EXTERNAL_LO_BAR_CHART',
          widget_type: 'TOP_EXTERNAL_LO_BAR_CHART',
          title: '',
          coordinates: {
            x: 1,
            y: 1,
            w: 1,
            h: 1,
          },
          rangeType: 'DAYS',
          minRangeDays,
          maxRangeDays,
          assignmentIds: [],
          isLoading: true,
        },
      ]
    : []),
];

export const shouldShowPerformance = (tool) => {
  const toolsId = getToolIds();
  return [toolsId.assessment, toolsId.learningcurve].includes(tool);
};
